import React from 'react'
import { Link } from 'react-router-dom'
import './TestCTA.scss'

const TestCTA = ({style}) => <Link to='/contato' style={style} className="btn-cta">Quero agendar um teste</Link>

export default TestCTA



// WEBPACK FOOTER //
// ./src/components/TestCTA/index.js